import {Expressions, Variable} from '@packages/systems/wfdl';
import {identifier} from '@packages/systems/wfdl-Qualified';
import {toSelectPath} from '@packages/utilities/wfdl-helpers';
import type {Expression} from '@packages/systems/wfdl-ast';

const contextVariable = Variable.unqualified(identifier('context'));

export type OverlayTargetReferenceParts = {
  componentKey: string;
  targetId: string;
  action: string | null;
};

export const getOverlayTargetReferenceParts = (
  expression: Expression,
  contextKey: string
): OverlayTargetReferenceParts | null => {
  const call = Expressions.getCall(expression);
  if (!call) return null;

  const targetCall = Expressions.getCall(call.fun);
  if (!targetCall) return null;

  const componentCall = Expressions.getCall(targetCall.fun);
  const componentKey = Expressions.getText(
    componentCall ? componentCall.arg : targetCall.arg
  );
  const targetId = Expressions.getText(
    componentCall ? targetCall.arg : call.arg
  );
  if (componentKey == null || targetId == null) return null;

  const {from, path} = toSelectPath(
    componentCall ? componentCall.fun : targetCall.fun
  );
  const variable = Expressions.getVariable(from);
  if (
    !variable ||
    !Variable.equals(contextVariable)(variable) ||
    path.length !== 1 ||
    path[0] !== contextKey
  ) {
    return null;
  }

  return {
    componentKey,
    targetId,
    action: componentCall ? Expressions.getText(call.arg) : null,
  };
};
